import ConstantStrings from "../../constants/ConstantStrings";
import { getConstantStringByLanguage } from "./getConstantStringByLanguage";

export const getLevelByGrade = (gradeName) => {
  var result = '';
  switch (gradeName) {
    case 'Lớp 1':
      result = 'Level 1';
      break;
    case 'Lớp 2':
      result = 'Level 1';
      break;
    case 'Lớp 3':
      result = 'Level 2';
      break;
    case 'Lớp 4':
      result = 'Level 2';
      break;
    case 'Lớp 5':
      result = 'Level 3';
      break;
    case 'Lớp 6':
      result = 'Level 3';
      break;
    case 'Lớp 7':
      result = 'Level 4';
      break;
    case 'Lớp 8':
      result = 'Level 4';
      break;
    case 'Lớp 9':
      result = 'Level 5';
      break;
    case 'Lớp 10':
      result = 'Level 5';
      break;
    case 'Lớp 11':
      result = 'Level 6';
      break;
    case 'Lớp 12':
      result = 'Level 6';
      break;
    default:
      break;
  }
  return result;
};

export const getLevelIKMCByGrade = (gradeName) => {
  var result = '';
  switch (gradeName) {
    case 'Lớp 1':
      result = `Level 1 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 1-2)`;
      break;
    case 'Lớp 2':
      result = `Level 1 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 1-2)`;
      break;
    case 'Lớp 3':
      result = `Level 2 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 3-4)`;
      break;
    case 'Lớp 4':
      result = `Level 2 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 3-4)`;
      break;
    case 'Lớp 5':
      result = `Level 3 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 5-6)`;
      break;
    case 'Lớp 6':
      result = `Level 3 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 5-6)`;
      break;
    case 'Lớp 7':
      result = `Level 4 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 7-8)`;
      break;
    case 'Lớp 8':
      result = `Level 4 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 7-8)`;
      break;
    case 'Lớp 9':
      result = `Level 5 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 9-10)`;
      break;
    case 'Lớp 10':
      result = `Level 5 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 9-10)`;
      break;
    case 'Lớp 11':
      result = `Level 6 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 11-12)`;
      break;
    case 'Lớp 12':
      result = `Level 6 (${getConstantStringByLanguage(ConstantStrings.GRADE)} 11-12)`;
      break;
    default:
      break;
  }
  return result;
};
